module.exports = __webpack_public_path__ + "img/P115.32e952cc.jpg";